const permissions = {
  listModule: 'UP009',
  addModule: 'UP010',
  editModule: 'UP011',
  deleteModule: 'UP012',
  reactivateModule: 'UP037'
};

export default permissions;
